// event-view.component.ts
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminEventComponent } from './adminCreatedEvent/admin-event.component';
import { StudentEventComponent } from './studentCreatedEvent/student-event.component';
import { TeacherEventComponent } from './teacherCreatedEvent/teacher-event.component';
import { UrlParserService } from '../../../shared/services/url-parser.service';

@Component({
  selector: 'event-view',
  standalone: true,
  imports: [
    CommonModule,
    AdminEventComponent,
    StudentEventComponent,
    TeacherEventComponent,
  ],
  templateUrl: './event-view.component.html',
  styleUrls: ['./event-view.component.scss'],
})
export class EventViewComponent implements OnInit, OnDestroy {
  eventCreatedBy: string = '';

  constructor(
    private route: ActivatedRoute,
    private urlParser: UrlParserService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const encodedSegment = params['segment'];
      if (encodedSegment) {
        const decodedSegment = this.urlParser.decodeId(encodedSegment);
        this.eventCreatedBy = decodedSegment;
      }
    });
  }

  ngOnDestroy(): void {}
}
